//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PackageSummarySearchOptions extends ItemBase {
    TeacherIDs: string[] = [];
    StudentIDs: string[] = [];
    Active: boolean | null = null;
    LastPurchaseName: string | null = null;

    constructor(initializer?: Partial<PackageSummarySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageSummarySearchOptions";
}
